const usePermissionConfig = () => {
  return {
    /*
    * 新增
    * 控制：新增
    * 跳转路由名称：
    * */
    CREATE: 'OPS-XTPZ-ZDGL-XZ',
    /*
    * 导出字典
    * 控制：导出字典
    * 跳转路由名称：
    * */
    OUTPUT: 'OPS-XTPZ-ZDGL-DCZD',
    /*
    * 导入字典
    * 控制：导入字典
    * 跳转路由名称：
    * */
    IMPORT: 'OPS-XTPZ-ZDGL-DRZD',
    /*
    * 下载导入模板
    * 控制：下载导入模板
    * 跳转路由名称：
    * */
    DOWNLOAD: 'OPS-XTPZ-ZDGL-XZDRMB',
    /*
    * 编辑
    * 控制：编辑
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-XTPZ-ZDGL-BJ',
    /*
    * 删除
    * 控制：删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-XTPZ-ZDGL-SC',
    /*
    * 值管理
    * 控制：值管理；值管理 - 新增；值管理 - 编辑；值管理 - 删除；值管理 - 启用停用；
    * 跳转路由名称：
    * */
    VALUEMANAGE: 'OPS-XTPZ-ZDGL-ZGL',
  };
};

export default usePermissionConfig;
